<h1 mat-dialog-title>{{'Select or create new category' | translate}}</h1>
<div mat-dialog-content >
    <mat-form-field class="example-form-field" appearance="fill" *ngIf="mainCategoryName">
        <mat-label>{{'Main category' | translate}}:</mat-label>
        <input matInput type="text" [(ngModel)]="mainCategoryName" [disabled]="true">
    </mat-form-field>

    <div class="flex">
        <mat-form-field class="example-form-field" appearance="fill">
            <mat-label>{{'Name' | translate}}:</mat-label>
            <input matInput type="text" [(ngModel)]="value" (ngModelChange)="filterCat($event)">
            <!-- <button *ngIf="value && !filteredCats.length" matSuffix mat-icon-button aria-label="add"
            (click)="addCategory()">
            <mat-icon>add_circle</mat-icon>
        </button> -->
            <button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clear()">
                <mat-icon>close</mat-icon>
            </button>

        </mat-form-field>
        &nbsp;
        <button *ngIf="value && !filteredCats.length && !editMode" mat-raised-button color="primary" aria-label="add" (click)="addCategory()">
            <!-- <mat-icon>add_circle</mat-icon> -->
            {{'Add Category' | translate}}
        </button>
    </div>

    <div *ngIf="editMode && data.editedCat && data.editedCat.image && !file">
        <img [src]="IMAGES_URL + data.editedCat.image" alt="" width="140px">
    </div>

    <ng-container *ngIf="value && !filteredCats.length">
        <p>
            <input type="file" accept='image/png' (change)="onFileChanged($event)" #fileInput>
        </p>
        <div style="display: flex;flex-direction: column;">
            <i>*Width & heights ratio - 1x1</i>
        </div>
    </ng-container>

    <div class="tags-container">
        <div *ngFor="let cat of filteredCats" class="tag">
            <a (click)="selectCat(cat)">
                {{cat.value}}
            </a>

            <a (click)="removeCat(cat)" class="remove">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" *ngIf="editMode" (click)="update()" [disabled]="!value">
        {{'Update' | translate}}
    </button>
    &nbsp;
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
</div>